<template>
  <div class="bg-white d-lg-none">
    <account-status />
  </div>
  <div
    class="navbar-mobile-shell d-lg-none"
    :style="isFixed && navHeight ? { height: `${navHeight}px` } : undefined"
  >
    <nav
      ref="navbarEl"
      class="navbar bg-danger d-block d-lg-none p-0 print vw-100 rounded-bottom-4"
      :class="[isFixed ? 'fixed-top' : '']"
    >
      <!-- <link-icon 
        class="col text-white gap-3"
        component="CartSvg" 
        :to="'/busqueda-por-categoria'"
    /> -->
      <LazyNavigationBannerBar :mobile="true" />
      <div class="d-flex justify-content-between align-items-center">
        <div class="col-1">
          <nuxt-link class="btn btn-link" :to="{ name: 'search_categories' }">
            <i class="bi bi-list text-white fs-1"></i>
          </nuxt-link>
        </div>
        <div class="col-4 text-white">
          <logo-digitalife height="20" width="160" />
        </div>
        <div class="col-6 d-flex gap-2 justify-content-end align-items-center">
          <nuxt-link to="/arma-tu-equipo" class="text-white fs-4 p-2 h-100">
            <i class="bi bi-tools"></i>
          </nuxt-link>
          <nuxt-link
            :to="{ name: 'cart-detail' }"
            class="text-white fs-4 p-2 h-100"
          >
            <i class="bi bi-cart-dash-fill"></i>
          </nuxt-link>
          <template v-if="mounted">
            <nuxt-link
              v-if="!isUserAuthenticated"
              class="text-white d-lg-none fs-4 p-2 h-100"
              :to="'/login'"
            >
              <i class="bi bi-person-circle"></i>
            </nuxt-link>
            <drop-down-menu-profile v-if="isUserAuthenticated" />
          </template>
        </div>
      </div>
      <base-transition>
        <div
          class="container-fluid bg-danger rounded-bottom-5 rounded-top-0 pt-2 mt-n1"
        >
          <suggestion-input type="mobile" />
          <button-notifications
            v-if="mounted && isUserAuthenticated"
            variant="bar"
            :mobile="true"
          />
        </div>
      </base-transition>
    </nav>
  </div>
</template>

<script lang="ts">
import BaseTransition from "@/components/common/BaseTransition.vue";
import LogoDigitalife from "~/components/icons/LogoDigitalife.vue";
import SuggestionInput from "~/components/navigation/SuggestionInput.vue";
import { getLinkSelfTranslate } from "@/utils/general";
import type { CartService } from "~/services/CartService";
import DropDownMenuProfile from "@/components/auth/DropDownMenuProfile.vue";
import auth from "~/services/AuthService";
import eventBus from "~/event-bus";
import axios from "axios";
import { VITE_API_ENDPOINT } from "~/config/constants";
import { CustomNotifyService } from "~/services/CustomNotifyService";
import { defineAsyncComponent } from "vue";
import { handleAxiosVerificationError } from "~/services/HandleAxiosVerificationError";
import useSearchStore from "~/stores/search";
import ButtonNotifications from "@/components/buttons/ButtonNotifications.vue";

const AccountStatus = defineAsyncComponent(
  () => import("@/components/common/AccountStatus.vue"),
);
const notifySrv = new CustomNotifyService();

export default {
  components: {
    BaseTransition,
    SuggestionInput,
    LogoDigitalife,
    DropDownMenuProfile,
    AccountStatus,
    ButtonNotifications,
  },
  setup() {
    return {
      searchStore: useSearchStore(),
    };
  },
  data: function () {
    return {
      cartService: null as CartService | null,
      loading: false,
      mounted: false,
      isFixed: false,
      navHeight: 0,
    };
  },
  computed: {
    isUserAuthenticated() {
      return auth.isUserLogged();
    },
  },
  mounted() {
    this.mounted = true;
    this.$nextTick(() => {
      this.measureNavbar();
      window.addEventListener("resize", this.measureNavbar);
      window.addEventListener("scroll", this.onScroll, { passive: true });
      this.onScroll();
    });
    // this.cartService = new CartService();
    // this.cartService.getCartInitData();
  },
  beforeUnmount() {
    eventBus.off("show-input-search");
    window.removeEventListener("resize", this.measureNavbar);
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    getLink(section: string, name: string) {
      return getLinkSelfTranslate(section, name);
    },
    measureNavbar() {
      const navbarEl = this.$refs.navbarEl as HTMLElement | undefined;
      this.navHeight = navbarEl?.offsetHeight || 0;
    },
    async resendEmail() {
      this.loading = true;
      const apiEndPoint = VITE_API_ENDPOINT.replace("/api", "");
      const path = "/email/verification-notification";
      try {
        const response = await axios.post(`${apiEndPoint}${path}`);
        if (response.status === 200) {
          notifySrv.getNotification({
            title: "Correo de verificación reenviado",
            text: response.data.message,
            time: 3000,
          });
          this.loading = false;
        }
      } catch (error) {
        handleAxiosVerificationError(error);
      }
    },
    onScroll() {
      this.isFixed = window.scrollY > 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.input-group input:focus {
  box-shadow: unset !important;
}

.navbar {
  z-index: 1020;
}

.navbar-mobile-shell {
  width: 100%;
}

@media print {
  body navbar.print {
    background-color: red;
    display: none;
  }
}
</style>
